const formatDate = (date: Date) => {
  const d = new Date(date);
  return d.toLocaleString('sv-SE', {
    dateStyle: 'short',
  });
};

export default formatDate;
